const state = {
  pagination: {
    page: 1,
    limit: 10,
    first: 0,
  },
  search: {
    query: '',
  },
  filters: {
    unit_number: null,
    date_from: null,
    date_to: null
  },
  sorting: {
    field: 'created_at',
    order: 'desc'
  },
  selectedRequest: null
};

const mutations = {
  updateRequestsPagination(state, {page, limit, first}) {
    state.pagination = { page, limit, first };
  },
  updateRequestsSearch(state, {query}) {
    state.search = { query };
  },
  updateRequestsFilters(state, {unit_number, date_from, date_to}) {
    state.filters = {
      unit_number: unit_number !== undefined ? unit_number : state.filters.unit_number,
      date_from: date_from !== undefined ? date_from : state.filters.date_from,
      date_to: date_to !== undefined ? date_to : state.filters.date_to
    };
  },
  updateRequestsSorting(state, {field, order}) {
    state.sorting = { field, order };
  },
  setSelectedRequest(state, request) {
    state.selectedRequest = request;
  },
};

const actions = {
  updateRequestsPagination({commit}, pagination) {
    commit('updateRequestsPagination', pagination);
  },
  updateRequestsSearch({commit}, search) {
    commit('updateRequestsSearch', search);
  },
  updateRequestsFilters({commit}, filters) {
    commit('updateRequestsFilters', filters);
  },
  updateRequestsSorting({commit}, sorting) {
    commit('updateRequestsSorting', sorting);
  },
};

const getters = {
  requestsPagination: state => state.pagination,
  requestsSearch: state => state.search,
  requestsFilters: state => state.filters,
  requestsSorting: state => state.sorting,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
